import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from "nprogress";


export const GetVisitorManagementRegionHelper = async (params) => {
     NProgress.start()
    return await axiosInstance(`/visitors/getVisitorManagementRegion`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        NProgress.done()
        return { message: "Regions retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done()
        return { message: "Unable to retrieve regions", hasError: true, data: err?.response?.data }
    });
};

export const AddVisitorManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/addVisitorManagementRegion`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            region: params?.region,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region added successfully");
        return { message: "Region added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add region", hasError: true, data: err?.response?.data }
    });
};

export const UpdateVisitorManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/updateVisitorManagementRegion`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            region: params?.region,
            visitors_management_regions_pk: params?.visitors_management_regions_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region updated successfully");
        return { message: "Region updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update region", hasError: true, data: err?.response?.data }
    });
};

export const DeleteVisitorManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/visitors/deleteVisitorManagementRegion`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            visitors_management_regions_pk: params?.visitors_management_regions_pk,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region deleted successfully");
        return { message: "Region deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete region", hasError: true, data: err?.response?.data }
    });
};
